import {findLast} from 'lodash';

export default function getDemoPositionMapboxStyle(
    layerTypes: {[key: string]: LayerType},
    layers: Layer[]
): mapboxgl.Style | undefined {
    const demoPositionLayer = findLast(layers, (layer: Layer) => {
        if (!layerTypes[layer.type]) return false;
        return layerTypes[layer.type].demoLon !== null;
    });
    if (!demoPositionLayer) return undefined;
    const demoPositionLayerType = layerTypes[demoPositionLayer.type];

    return {
        version: 8,
        center: [demoPositionLayerType.demoLon!, demoPositionLayerType.demoLat!],
        zoom: demoPositionLayerType.demoZoom || undefined
    };
}
